define('plugin/product/ProductPlugin',['require','lib/plugin/PluginAbstract','plugin/product/view/ProductListView','plugin/product/view/ProductDeliveryView','plugin/product/collection/ProductCollection','plugin/product/collection/ProductPaginatedCollection','plugin/product/collection/ProductCategoryCollection','plugin/product/controller/ProductController','lib/AppRouter','Config','plugin/product/view/ProductCartListView','plugin/product/model/ProductCartModel','plugin/product/model/ProductDeliveryModel','plugin/product/view/ProductBookingDetailsView'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var ProductListView = require('plugin/product/view/ProductListView');
    var ProductDeliveryView = require('plugin/product/view/ProductDeliveryView');
    var ProductCollection = require('plugin/product/collection/ProductCollection');
    var ProductPaginatedCollection = require('plugin/product/collection/ProductPaginatedCollection');
    var ProductCategoryCollection = require('plugin/product/collection/ProductCategoryCollection');
    var ProductController = require('plugin/product/controller/ProductController');
    var AppRouter = require('lib/AppRouter');
    var Config = require('Config');

    var ProductCartListView = require('plugin/product/view/ProductCartListView');
    var ProductCartModel = require('plugin/product/model/ProductCartModel');
    var ProductDeliveryModel = require('plugin/product/model/ProductDeliveryModel');
    var ProductBookingDetailsView = require('plugin/product/view/ProductBookingDetailsView');

    return PluginAbstract.extend({

        _bookingModel: null,
        _collection: null,
        _listCollection: null,
        _categoryCollection: null,
        _detailsStepView: null,
        _productRegions: {
            product: '#sb_product_container',
            productCart: '#sb_product_cart_container',
        },
        // _productModuleRegions: {
        //     productCartModule: '#sb_product_cart'
        // },
        _cartRegion: null,

        _page: 1,
        _onPage: 4,
        _type: 'product',

        _supportsCart: true,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.initCartModel();
            this.initDeliveryModel();
            this.initListCollection();
            this.initRoutes();
            this.subscribeInvoiceViewEvents();
        },

        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();

            this.listenTo(this._stepManager, 'step:render:details', this.beforeDetailsShow);
            this.listenTo(this._bookingModel, 'change:service_id', this._resetCollection)

            this.getOption('app').module.cart.setStepManager(this._stepManager);
        },

        /**
         * Reset product collection
         *
         * @private
         */
        _resetCollection: function () {
            this._collection = null;
        },

        /**
         * Instantiate product collection in case it is null
         *
         * @private
         * @return ProductCollection
         */
        _getCollection: function () {
            if (!this._collection) {
                this._collection = new ProductCollection();
                this._collection.load({
                    data: {
                        'service_id': this._bookingModel.get('service_id'),
                        'type': this._type
                    }
                });

                this.listenTo(this._collection, 'change', this.updateProducts);
                this.listenTo(this._collection, 'sync', this.updateProducts);
            }

            return this._collection;
        },

        updateProducts: function () {
            var products = [];
            var _this = this;
            if (this._collection) {
                var selectedAddons = _this._bookingModel.get('addons');
                var selectedAddonsArr = [];
                if (selectedAddons && selectedAddons !== 'no') {
                    selectedAddonsArr = selectedAddons.split(',');
                }
                this._collection.each(function (model) {
                    if (
                        model.get('type') === 'attribute'
                        && (selectedAddonsArr.length || selectedAddons === 'no')
                        && !_.contains(selectedAddonsArr, model.get('id'))) {
                        
                        return;
                    }

                    if (parseInt(model.get('qty')) > 0) {
                        products.push(model.toJSON());
                    }
                });
            }

            _.each(this._bookingModel.get('products'), function (model) {
                if (model.type !== this._type) {
                    products.push(model);
                }
            }, this);

            this._bookingModel.set('products', products);
        },

        /**
         * Before details step shown add product list region
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        beforeDetailsShow: function (step, view, region) {
            this._detailsStepView = view;
            _.each(this._productRegions, function (selector, region) {
                view.addRegion(region, selector);
            });

            if (this._getListRegion().$el.data('onpage')) {
                this._onPage = parseInt(this._getListRegion().$el.data('onpage'));
            }

            this._getListRegion().reset();

            if(this._bookingModel.get('wl')){
                return; //do not show products if waiting list
            }

            var collection = this._getCollection();
            this.listenTo(collection, 'sync', _.bind(function () {
                this._showListView(collection);
            }, this));
            this._showListView(collection);

            this.showCartProductsOnBookingDetails();

            //TODO handle booking submit
        },

        showCartProductsOnBookingDetails: function () {
            if (this.isCartEnabled() && !this._cartModel.isEmpty()) {
                var view = new ProductBookingDetailsView({
                    model: this._cartModel
                });
                this._getCartRegion().show(view);
            }
        },

        _showListView: function (collection) {
            if (collection.length) {
                this._getListRegion().show(
                    this._getListView(collection)
                );
            }
        },

        /**
         * Display list view in proper region
         *
         * @return Region
         */
        _getListRegion: function () {
            return this._detailsStepView.product;
        },

        _getCartRegion: function () {
            return this._detailsStepView.productCart;
        },

        /**
         * Return plugin list view
         *
         * @param collection
         * @return {*}
         */
        _getListView: function (collection) {
            var view = new ProductListView({
                bookingModel: this._bookingModel,
                collection: collection
            });

            view.setPage(this._page);
            view.setOnPage(this._onPage);

            this.listenTo(view, 'page:changed', this.triggerPageShown);

            return view;
        },

        /**
         * Triggers page shown to scroll up to products
         */
        triggerPageShown: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': this._type
            });
        },

        /**
         * After save booking
         *
         * @param Object data
         */
        afterSaveBooking: function (data) {
            this._resetCollection();
        },

        /**
         * Inits membership routes
         */
        initRoutes: function () {
            if (Config.getInstance().getOption('product_use_menu')) {
                var productRouter = new AppRouter({
                    appRoutes: {
                        'products(/category/:category)(/sort/:sort)(/page/:page)(/)': 'index',
                        'products/buy(/)': 'buyWithClientInfo',
                    },
                    menuItem: 'product',
                    controller: new ProductController({
                        app: this.getOption('app'),
                        collection: this._listCollection, 
                        categoryCollection: this._categoryCollection, 
                        // clientModel: this._clientModel,
                        clientModel: this.getOption('clientModel'),
                        cartModel: this._cartModel
                    })
                });
            }
        },

        initModules: function (layout) {
            if (this.isCartEnabled()) {
                if (!this._cartModuleAdded) {
                    var cartRegion = this._cartRegion = this.getOption('app').module.cart.addItem(this._cartModel, 'products');
                    this._cartModuleAdded = true;
                
                    var productCartView = new ProductCartListView({
                        model: this._cartModel
                    });
                    setTimeout(function(){
                        cartRegion.show(productCartView);
                    }, 500); //TODO fix this hack - listen to when cart view id rendered???
                }
            }
        },

        initCartModel: function () {
            if (this.isCartEnabled()) {
                this._cartModel = new ProductCartModel();
                this._cartModel.load();
                // this.listenTo(this._cartModel, 'after:checkout', this.finishBooking); //TODONOW - check if this is needed
            } 
        },

        initDeliveryModel: function () {
            if (this.isCartEnabled()) {
                this._deliveryModel = new ProductDeliveryModel();
                this._deliveryModel.fetch();
            } 
        },

        initListCollection: function () {
            this._listCollection = new ProductPaginatedCollection();
            if (Config.getInstance().getOption('product_use_categories')) {
                this._categoryCollection = new ProductCategoryCollection();
            }
        },

        subscribeInvoiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('invoice:layout').vent.on(
                'show', _.bind(this.onInvoiceLayoutShow, this)
            );
        },

        onInvoiceLayoutShow: function (data) {
            var layout = data.view;
            var model = data.model;

            var lineTypes = model.getLineTypes();

            if (lineTypes.has_products && !lineTypes.has_bookings) {
                var view = new ProductDeliveryView({
                    model: this._deliveryModel
                });
                layout.getProductDeliveryRegion().show(view);
            }
        },

        /**
         * @param BookingServerRequestModel requestModel
         */
        beforeSaveBooking: function (requestModel) {
            if (this.isCartEnabled()) {
                //TODO check the multiple booking case
                if (this._cartModel.getQty() > 0) {
                    requestModel.set({
                        'products': this._cartModel.get('items')
                    });
                }
            }
        },

        finishBooking: function (data) {
            if (this.isCartEnabled()) {
                this._cartModel.clear();
            }
        },

        isCartEnabled: function () {
            return Config.getInstance().getOption('product_use_menu') && this._supportsCart;
        },

    });

});
